import { set, toggle } from '@/utils/vuex'

export default {
  setRefreshRequired: set('refreshRequired'),
  setHeroGraphData: set('heroGraphData'),
  setSnFilter: set('snFilter'),
}
